export enum IntervalPromiseStatusEnum {
    Initialized = 0,
    Cancelled = 2
}